if (!customElements.get('swatch-product-data')) {
  customElements.define(
    'swatch-product-data',
    class BundleProductSwatch extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.toggleImage.bind(this));
        this.addEventListener('keydown', (e) => {
         if (e.key === 'Enter') {
            this.toggleImage(this)
          }
        });
      }
      toggleImage() {     
        if (this.classList.contains('current-active-variant')) return;
        const product = this.closest('.bundle-product-main-wrapper');
        const oldHandle = product.querySelector('.current-active-variant').dataset.productUrl;
        const index = product.dataset.index
        const modalPopup = this.closest('.bundle-popup-modal__content');
        var sectionName =  'pdp-bundle-product'
        if(window.matchMedia('(max-width: 768px)').matches){
          var sectionName =  'pdp-bundle-product-mobile'
        }
        fetch(`${this.dataset.productUrl}?sections=${sectionName}`)
          .then(response => response.json())
          .then(response => {   
            console.log('togggle');
            var targetElement = modalPopup.querySelector(`.bundle-product-main-wrapper[data-id="${product.dataset.id}"][data-index="${index}"]`);
            var responseString = response[`${sectionName}`];
            var parser = new DOMParser();
            var responseDoc = parser.parseFromString(responseString, 'text/html');
            targetElement.innerHTML = responseDoc.querySelector('.bundle-section-pdp-main').innerHTML;
            imageArea(modalPopup, oldHandle, this.dataset.productUrl);
            trapFocus(modalPopup);
            calculateSubTotal(modalPopup);
            checkAddedVariants(modalPopup);
          })
          .catch(console.error);
      }
    }
  )
}

if (!customElements.get('bundle-card')) {
  customElements.define(
    'bundle-card',
    class BundleModal extends HTMLElement {
      constructor() {
        super();
        this.querySelector('modal-opener')?.addEventListener('click', this.modal.bind(this));
        // this.modelOpenerButtons = this.querySelectorAll('.quick-style-button');
        this.reverseCheckboxes = this.querySelectorAll('input[name="reverse-option"]');
        this.reverseCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              this.toggleChecked(checkbox);
              this.updateButtonClass(checkbox);
            }
          });
          // checkbox.addEventListener('change', () => {
          //   this.updateButtonClass(checkbox);
          // });
        });
      }
    
      toggleChecked(check){
        check.checked ? check.checked = false : check.checked = true
      }
      // updateButtonClass(checkbox) {
      //   const reverseModels = document.querySelectorAll(".bundle-popup-modal");
      //   this.modelOpenerButtons.forEach(button => {
      //       const reverseId = button.getAttribute('data-reverse-image-id');
      //       reverseModels.forEach(model => {
      //         const modelId = model.id; 
      //         if ( reverseId === modelId){
      //           if (checkbox.checked) {
      //             model.classList.add("reverse-option-true");
      //           }
      //           else{
      //             model.classList.remove("reverse-option-true");
      //           }
      //         }
      //       });
            
      //   });
      // }
      modal(event) {
        document.body.classList.add('overflow-hidden');
        //console.log(event.target)
        const modalPopup = document.querySelector(event.target.getAttribute('data-modal'));
        modalPopup.classList.add('loading');
        flushAddedVariants(modalPopup);
        var sectionName =  'pdp-bundle-product'
        if(window.matchMedia('(max-width: 768px)').matches){
          sectionName =  'pdp-bundle-product-mobile'
        } 
        const products = modalPopup.querySelectorAll('.bundle-product-main');
        const fetchProducts = async (products) => {
          const fetchPromises = Array.from(products).map((product, index) =>
            fetch(`${product.dataset.url}?sections=${sectionName}`)
              .then(response => response.json())
              .then(response => {
                console.log('first time');
                var targetElement = modalPopup.querySelector(`.bundle-product-main-wrapper[data-id="${product.dataset.id}"]`);
                if(targetElement) {
                  var responseString = response[`${sectionName}`];
                  var parser = new DOMParser();
                  var responseDoc = parser.parseFromString(responseString, 'text/html');
                  targetElement.innerHTML = responseDoc.querySelector('.bundle-section-pdp-main').innerHTML;
                  targetElement.setAttribute('data-index', index + 1);
                }
              })
              .catch(console.error)
          );
          await Promise.all(fetchPromises);
        };
        fetchProducts(products).then(() => {
          modalPopup.classList.remove('loading');
          trapFocus(modalPopup)
          calculateSubTotal(modalPopup);
          allATCTrigger(modalPopup);
          imageArea(modalPopup);
          reverseImage(modalPopup);
          _swat.initializeActionButtons("body");
        });
      }
    }
  )
}

function calculateSubTotal(modalPopup) {
  var subTotal = 0;
  modalPopup.querySelectorAll('product-info').forEach(function(e) {
    if (e.querySelector('[type="submit"]').disabled == false) {
      subTotal += parseInt(e.querySelector('.modal-product-price').dataset.money);
    }
  });
  modalPopup.querySelector('.sub_total').textContent = theme.Currency.formatMoney(subTotal, window.shopSettings.moneyFormat);
}

function afterBundleVariantCart(variant) {
  const x = document.querySelector('#addedVariants')?.textContent || '[]';
  const m = JSON.parse(x);
  m.push(variant);
  document.querySelector('#addedVariants').textContent = JSON.stringify(m);
}

function flushAddedVariants(modalPopup) {
  document.querySelector('#addedVariants').textContent = '';
  modalPopup.querySelector('#all_atc').classList.remove('redirect');
  modalPopup.querySelector('#all_atc').textContent = window.variantStrings.bundle_all_atc;
}

function checkAddedVariants(modalPopup) {
  const x = document.querySelector('#addedVariants')?.textContent || '[]';
  const m = JSON.parse(x);
  var variantId = 0;
  var variantIds = [];
  var found = false;
  var url_button_desk = modalPopup.querySelector('#ids-for-variants');
  var custom_build_url = modalPopup.querySelector('#ids-for-variants-tool');

  var url_button_mobile = modalPopup.querySelector('#ids-for-variants-mobile');
  var custom_build_url_mobile = modalPopup.querySelector('#ids-for-variants-tool-mobile');

  modalPopup.querySelectorAll('product-info').forEach(function(e) {
    
    variantId = e.querySelector('form').querySelector('[name=id]').value;
    var is_soldout = e.querySelector('form').querySelector('[type="submit"]').hasAttribute('disabled');
    var default__id = e.querySelector('variant-selects fieldset')?.getAttribute('default_id');
  
 
  if( !is_soldout ){
    variantIds.push(variantId);
  } else {
    variantIds.push(default__id);
  }
  variantIds = variantIds.filter(item => item !== null && item !== undefined && item !== "");
 
  
// Add a click event listener to each radio button
   

    if (m.includes(variantId)) {
      found = true;
      console.log('1')
      //e.querySelector('product-form').toggleSubmitButton(true);
      e.querySelector('product-form').querySelector('[type="submit"]').classList.add('added');
      e.querySelector('product-form').querySelector('[type="submit"]').querySelector('span').innerHTML = `${window.variantStrings.added} <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.78947L5.13793 9L13 1" stroke="currentColor"/></svg>`;
      
    }
   

    if (custom_build_url) {

      if (variantIds.length === 0){
        url_button_desk.style.pointerEvents = 'none';
        url_button_desk.style.opacity = '0.5';
      }else {
        url_button_desk.style.pointerEvents = '';
        url_button_desk.style.opacity = '1';
      }
      const baseUrl = 'https://modular.marfastance.com/build/?products=';
      const toolUrl = `${baseUrl}${variantIds.join(',')}`; // Append variant IDs as a comma-separated string
  
      // Set the href attribute of the button
      if (custom_build_url) {
          custom_build_url.textContent  = JSON.stringify(variantIds);
          url_button_desk.setAttribute('href', toolUrl); // Set the dynamically created URL
      } 
     
    }
    if (custom_build_url_mobile) {
      if (variantIds.length === 0){
        url_button_mobile.style.pointerEvents = 'none';
        url_button_mobile.style.opacity = '0.5';
      }else {
        url_button_mobile.style.pointerEvents = '';
        url_button_mobile.style.opacity = '1';
      }
      const baseUrl = 'https://modular.marfastance.com/build/?products=';
      const toolUrl = `${baseUrl}${variantIds.join(',')}`; // Append variant IDs as a comma-separated string
  
      // Set the href attribute of the button
      if (custom_build_url_mobile) {
        custom_build_url_mobile.textContent  = JSON.stringify(variantIds);
        url_button_mobile.setAttribute('href', toolUrl); // Set the dynamically created URL
      } 
    }
  });



  if (found) {
    modalPopup.querySelector('#all_atc').classList.add('redirect');
    modalPopup.querySelector('#all_atc').textContent = window.variantStrings.bundle_all_atc_disabled;
  } else {
    modalPopup.querySelector('#all_atc').classList.remove('redirect');
    modalPopup.querySelector('#all_atc').textContent = window.variantStrings.bundle_all_atc;
  }
  reverseImage(modalPopup);
  _swat.initializeActionButtons("body");
}

 function allATCTrigger(modalPopup) {
  modalPopup.querySelector('#all_atc').addEventListener('click', async function (e) {
    e.preventDefault();
    
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (e.currentTarget.classList.contains('redirect')) {
      modalPopup.closest('modal-dialog').hide();
      console.log("---------------");
      setTimeout(() => {
        cart.open();
        cart.style.transform = 'translateY(100%)';
        cart.style.transition = 'transform .5s ease-in-out, visibility .5s ease-in-out';
         requestAnimationFrame(() => {
          cart.style.transform = 'translateY(0)';
          cart.style.transition = "transform .5s ease-in-out, visibility .5s ease-in-out";
        });
      }, 1500);
      return false;
    }
    var items = [];
    modalPopup.querySelectorAll('product-info').forEach((pi) => {
      console.log('Checking 2 g');
      const form = pi.querySelector('form'); // Select the form within each product-info
      if (form) {
        const formData = new FormData(form);
        items.push({
          'id': formData.get('id'),
          'quantity': 1
        });
      }
    });

    const formData = {
      sections: 'cart-drawer,cart-icon-bubble',
      items: items
    };
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData),

      });
      if (response.ok != false && response.status  != 422 ){
        const data = await response.json();
        setTimeout(() => {
          cart.renderContents(data);
        }, 1500);
        // Assuming the request is successful, hide the modal and open the cart
        modalPopup.closest('modal-dialog')?.hide();
        if (cart.classList.contains("is-empty") ){
          cart.classList.remove("is-empty");
        }
        setTimeout(() => {  
          cart.open();
          cart.style.transform = 'translateY(100%)';
          cart.style.transition = 'transform .5s ease-in-out, visibility .5s ease-in-out';
          requestAnimationFrame(() => {
            cart.style.transform = 'translateY(0)';
            cart.style.transition = "transform .5s ease-in-out, visibility .5s ease-in-out";
          });
        }, 1500);
        return data;
      }
      else{
        let messageContainers = document.querySelectorAll('.error-message.quantity-error-message');

        messageContainers.forEach((messageContainer) => {
          messageContainer.classList.remove('hidden');
          
          setTimeout(() => {
            messageContainer.classList.add('hidden');
          }, 7000);
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }

  });
}

if (!customElements.get('image-reverse')) {
  customElements.define(
    'image-reverse',
    class imageReverSwitch extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector('input[type="checkbox"]')
        this.checkbox?.addEventListener('keydown', (e) => {
         if (e.key === 'Enter') {
            this.togglerReverseImage(this.checkbox)
          }
        });
      }
      togglerReverseImage(check) { 
        check.checked ? check.checked = false : check.checked = true
      }
    }
  )
}

function reverseImage(modalPopup) {
  const reverseOption = modalPopup.querySelectorAll('.bundle-product-main image-reverse input[name=reverse-option]');
  const mainImgeOption = modalPopup.querySelector('.modal-left-content .reverse-quickview-option input[name=reverse-quickview-option]');
  const reverseImages = modalPopup.querySelectorAll('.modal-left-content .bundle-card__media.bundle-main-image.reverse-image ');
  const frontImages = modalPopup.querySelectorAll('.modal-left-content .bundle-card__media.bundle-main-image.front-image ');

  // Set default styles
  reverseImages.forEach(image => {
    image.style.display = 'none';
    image.style.opacity = '1';
  });
  frontImages.forEach(image => {
    image.style.display = 'block';
    image.style.opacity = '1';
  });
  
 modalPopup.querySelectorAll('.modal-left-content .image-area .bundle-card__media img[z-index]').forEach(img => {
    // Get the z-index attribute value
    const zIndex = img.getAttribute('z-index');
    
    if (zIndex) {
      // Set the z-index as a style on the parent `.bundle-card__media`
      img.closest('.bundle-card__media').style.zIndex = zIndex;
    }
  });


     function toggleImages() {
      reverseImages.forEach(image => image.style.display = 'block');
      frontImages.forEach(image => image.style.display = 'none');
    }

    function setDefaultImages() {
      reverseImages.forEach(image => image.style.display = 'none');
      frontImages.forEach(image => image.style.display = 'block');
    }
  
  function checkAllInputs() {
    console.log('checkAllInputs')
    const allChecked = Array.from(reverseOption).every(input => input.checked);
    console.log(allChecked)
    mainImgeOption.checked = allChecked;
    if (allChecked) {
      toggleImages();
    } else {
      setDefaultImages();
    }
  }

  function checkSingleInputs() {
      const selectedValues = Array.from(reverseOption)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value.split('|')[1]);
    
    reverseImages.forEach(image => {
      if (selectedValues.includes(image.dataset.handle)) {
        image.style.display = 'block'  
      } else {
        image.style.display = 'none'  
      }
    });
    frontImages.forEach(image => {
      if (selectedValues.includes(image.dataset.handle)) {
        image.style.display = 'none'  
      } else {
        image.style.display = 'block'  
      }
    });
  }
  
  if (window.innerWidth > 768) {
    reverseOption.forEach(input => {
      input.addEventListener('change', checkSingleInputs);
    });
   
    checkAllInputs();
  }
  else{
    function ReverseOptionsChange() {
      reverseOption.forEach(option => {
        option.checked = mainImgeOption.checked;
      });
      checkAllInputs();
    }
    mainImgeOption.addEventListener('change', function() {
      ReverseOptionsChange();
    });
    if (mainImgeOption.checked) {
      ReverseOptionsChange();
    }
  }
}

function imageArea(modalPopup, oldHandle = '', newHandle = '') {

  if (window.shopSettings.layerToggle == false) {
    modalPopup.querySelector('.image-area').insertAdjacentHTML('beforeend', modalPopup.querySelector('.image-area-default').innerHTML);  
    return true;
  }
  
  //return true;
  console.log('imageArea')
  var bundleProducts = [];
  modalPopup.querySelectorAll('product-info').forEach((pi) => {
    const imageProductArea = pi.querySelector('.imageProductArea'); // Select the form within each product-info
    bundleProducts.push(imageProductArea);
  });
  
  // Conversion of Liquid templates to JavaScript.
  
  // Parent Code in JavaScript
  let combinationFound = false;
  let collarFound = false;
  let hoodDropFound = false;

  if (bundleProducts.length <= 0) {
    return;
  }

  const imageArea = modalPopup.querySelector('.image-area');
  if (imageArea) {
      let mediaElements = imageArea.querySelectorAll('.bundle-card__media');
      mediaElements.forEach((element) => {
          if (oldHandle) {
              if (element.dataset.handle === oldHandle) {
                  element.remove();
              }
          } else {
              element.remove();
          }
      });
  }
  // Check for specific product build types
  bundleProducts.forEach((product) => {
      if (product?.dataset.collar) {
          collarFound = true;
      } else if (product?.dataset.hood) {
          hoodDropFound = true;
      }
      if (hoodDropFound && collarFound) {
          combinationFound = true;
      }
  });
  
  // Render images based on conditions
  bundleProducts.forEach((product) => {
      const productImages = product;
      const productBuildType = product?.dataset.hood ? 'hood' : product?.dataset.collar ? 'collar' : '';
  
      if (productImages) {
        const mediaElements = productImages.querySelectorAll('.bundle-card__media');
        if (mediaElements.length > 0) {
          renderBundleProductImages({
              images: productImages,
              combined: combinationFound,
              collarImage: productBuildType,
          });

          if (newHandle) {
            if (product.dataset.url != newHandle) {
              return;
            }
          }
          modalPopup.querySelector('.image-area').insertAdjacentHTML('beforeend', product.innerHTML);
        }
      }
  });

  const firstElements = modalPopup.querySelectorAll('.image-area .bundle-card__media.front-image');
  const reverseElements = modalPopup.querySelectorAll('.image-area .bundle-card__media.reverse-image');

  if (newHandle) { return; }
  var foundImages = false;
  if (firstElements.length > 0) {
    firstElements[0].style.position = 'relative';
    firstElements[0].style.top = '0px';
    firstElements[0].style.left = '0px';
    firstElements[0].style.transform = 'none';
    foundImages = true;
  }
  if (reverseElements.length > 0) {
    reverseElements[0].style.position = 'relative';
    reverseElements[0].style.top = '0px';
    reverseElements[0].style.left = '0px';
    reverseElements[0].style.transform = 'none';
    foundImages = true;
  }

  if (!foundImages) {
    modalPopup.querySelector('.image-area').insertAdjacentHTML('beforeend', modalPopup.querySelector('.image-area-default').innerHTML);  
  }
  

}
// Function to handle rendering images (equivalent to rendering the child template)
function renderBundleProductImages({ images, combined, collarImage }) {
    if (combined) {
        images.querySelectorAll('.bundle-card__media').forEach((imgDiv) => {
            if (collarImage) {
                let zIndex = imgDiv.style.zIndex; // Get inline z-index directly
        
                if (parseInt(zIndex, 10) === 45) {
                    imgDiv.style.zIndex = "15"; // Update z-index
                    console.log(`Updated inline z-index to 15 for`, imgDiv);
                }
            }
        });
    }

}